import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AccountResponse} from "../../../model/response/account-response.model";

@Component({
    selector: 'app-user-info-modal',
    templateUrl: './user-info-modal.component.html',
    standalone: false
})
export class UserInfoModalComponent implements OnInit{

  @Input('user') user: AccountResponse
  @Input('display') displayModal: boolean
  @Output('onCancelModal') onCancelModalEmitter = new EventEmitter()

  constructor() {
  }

  ngOnInit() {
  }

}
